import React from 'react'

function Loader() {
    return (
        <div className=' h-screen flex justify-center items-center space-x-4'>
            <div
                className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-[#a3391f]  border-r-transparent align-[-0.125em] text-primary motion-reduce:animate-[spin_1.5s_linear_infinite]"
                role="status">
                {/* <span
                    class="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]"
                >Loading...</span> */}
            </div>
            <p className='text-[#a3391f] font-[600] text-xl tracking-widest animate-pulse'>Loading . . .</p>
        </div>
    )
}

export default Loader